"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgDial = function SvgDial(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 27"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#C2C5CC"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 0.5,
    y: 0.5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 0.5,
    y: 7.5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 7.5,
    y: 7.5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 14.5,
    y: 7.5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 0.5,
    y: 14.5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 7.5,
    y: 14.5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 7.5,
    y: 21.5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 14.5,
    y: 14.5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 7.5,
    y: 0.5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 14.5,
    y: 0.5,
    rx: 2.5
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgDial);
var _default = exports["default"] = Memo;